import { Box, Flex } from '@chakra-ui/react'
import DisplayStaticNewsFeed from '../dsr-content-components/DisplayStaticNewsFeed'
import DsrConfirmationModal from '../components/DsrConfirmationModal'
import { useEffect, useState } from 'react'
import { bindActionCreators } from 'redux'
import {
  loadMoreFeedContentAct
} from '../actions/dsr-actions'
import { connect } from 'react-redux'
import { useParams, withRouter } from 'react-router-dom'
import RenderDraftSubpageContent from './RenderDraftSubpageContent'
import DsrDraftSideMenu from './DsrDraftSideMenu'
import EmbeddedZoomMeetingDisplay from '../dsr-zoom/EmbeddedZoomMeetingDisplay'
import useChangeSubpageDisplay from '../../global/hooks/change-subpage-display'

// Note: Render Dsr Content for DRAFT states
const RenderDraftDsrContent = ({
  isRoomTemplate,
  pagesLocalState,
  replaceDsrPages,
  addDsrPage,
  removeDsrPage,
  handleChangeUserActionRequired,
  // Actions
  loadMoreFeedContentAct,
  // Redux
  dsrActionList,
  selectedDisplaySubpage,
  dsrTitleRedux,
  showLoadMoreRedux,
  loadingMoreContentRedux,
  selectedDisplayPageId,
  dsrPropertiesRedux, 
  dsrTeamMembersRedux,
  dsrFeedContent,
  duplicateDsrPage,
  isMobileView
}) => {
  const { dsrId } = useParams()
  const { handleSelectSubpage } = useChangeSubpageDisplay();

  const [localState, setLocalState] = useState({
    showConfirmationModal: false,
    confirmationType: '',
  })
  const [extraHeaderLayoutOffset, setExtraHeaderLayoutOffset] = useState(false)

  useEffect(() => {
    if (isRoomTemplate) {
      setExtraHeaderLayoutOffset(true)
    } else if (dsrPropertiesRedux.logoDisplayOption) {
      if (dsrPropertiesRedux.logoDisplayOption === "default") {
        !!extraHeaderLayoutOffset && setExtraHeaderLayoutOffset(false)
      } else {
        !extraHeaderLayoutOffset && setExtraHeaderLayoutOffset(true)
      }
		}
	}, [isRoomTemplate, dsrPropertiesRedux.logoDisplayOption]);

  
  // Functions to change frontend local state of dsrPages
  const handleConfirmationModalClose = () => {
    setLocalState(() => ({
      showConfirmationModal: false,
      confirmationType: '',
    }))
  }


  const loadMoreFeedContent = () => {
    dsrId && loadMoreFeedContentAct(dsrId)
  }

  // have new state that controls displaying loader inside Modal
  return (
    <Flex className='dsr-content__section'>
      <Flex className='dsr-content__container'>
        <Flex direction="column" align="flex-start" w='100%' minHeight="40em">
        
          <Flex direction="row" align="flex-start" width="100%" height='100%'>
            <Flex bg="white" position='sticky' top='140px'>
              <DsrDraftSideMenu
                isRoomTemplate={isRoomTemplate}
                pageArray={pagesLocalState}
                handleSelectSubpage={handleSelectSubpage}
                addNewDsrPage={addDsrPage}
                removeDsrPage={removeDsrPage}
                selectedDisplayPageId={selectedDisplayPageId}
                selectedDisplaySubpage={selectedDisplaySubpage}
                replaceDsrPages={replaceDsrPages}
                duplicateDsrPage={duplicateDsrPage}
                // applyBranding={dsrPropertiesRedux.applyBranding}
                altPageNames={dsrPropertiesRedux.altPageNames}
                extraHeaderLayoutOffset={extraHeaderLayoutOffset}
              />
            </Flex>
            <Flex
              direction={['column', 'column', 'row', 'row']}
              justify="center"
              flexWrap="wrap"
              width="100%"
              bg='#F4F4F4'
              height='100%'
            >
              <Box mt={extraHeaderLayoutOffset ? '3em' : '2em'} w="100%" px="3em" maxWidth='900px' pb='3em'>
                {selectedDisplaySubpage === 'updates-subpage' ?
                <Box>
                  <DisplayStaticNewsFeed
                    dsrTitle={dsrTitleRedux}
                    postContent={dsrFeedContent}
                    loadMoreFeedContent={loadMoreFeedContent}
                    showLoadMore={showLoadMoreRedux}
                    loadingMoreContent={loadingMoreContentRedux}
                    dsrTeamMembers={dsrTeamMembersRedux}
                    handleSelectSubpage={handleSelectSubpage}
                    isMobileView={isMobileView}
                  />
                </Box> :
                  <RenderDraftSubpageContent
                    dsrPagesLocalState={pagesLocalState}
                    dsrId={dsrId}
                    dsrActionList={dsrActionList}
                    replacePages={replaceDsrPages}
                    dsrProperties={dsrPropertiesRedux}
                    handleChangeUserActionRequired={handleChangeUserActionRequired}
                    handleSelectSubpage={handleSelectSubpage}
                  />
                  }
                  <EmbeddedZoomMeetingDisplay />         
                </Box>
            </Flex>

            {/* // This section houses dynamically rendered components that depends on user journey */}
            {localState.showConfirmationModal && localState.confirmationType && (
              <DsrConfirmationModal
                // Logics
                confirmationType={localState.confirmationType} // Get from state to make this dynamic
                // Function
                handleCloseConfirmationModal={handleConfirmationModalClose}
              />
            )}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

const mapStateToProps = (state) => ({
  selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
  dsrFeedContent: state.dsrFeedContent.results,
  dsrActionList: state.dsrActionList.results.data,
  dsrTeamMembersRedux: state.dsrTeamMembers.members,
  dsrTitleRedux: state.dsrTitle.title,
  showLoadMoreRedux: state.dsrFeedContent.allowLoadMore,
  loadingMoreContentRedux: state.dsrFeedContent.isLoading,
  dsrPropertiesRedux: state.draftDsrProperties.properties,
  selectedDisplayPageId: state.changeDsrPage.selectedDisplayPageId,
  isRoomTemplate: state.dsrTemplateId.isRoomTemplate,
  isMobileView: state.mobileViewMode.isMobileView
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadMoreFeedContentAct
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RenderDraftDsrContent))
